var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.957.345 12.016 12.322L1.957 24.988a1.14 1.14 0 0 1-1.7-1.516l.066-.073 10.47-10.732L.323 1.935A1.14 1.14 0 0 1 .278.395L.345.322a1.14 1.14 0 0 1 1.54-.045l.072.067Z",
    fill: "#fff"
  })));
};
export default SvgLeftArrow;